module.exports = __webpack_public_path__ + "static/interview-references-b73637f88d6d339fec9ef5047c73042a.jpg";